import { Injectable } from "@angular/core";
import { Observable, ReplaySubject, tap } from "rxjs";
import { IUserData } from "./user.interface";
import { HttpClient } from "@angular/common/http";
import { environment } from "environments/environment";

@Injectable({
    providedIn: 'root'
})
export class UserService {
    private _userInfo: ReplaySubject<IUserData> = new ReplaySubject<IUserData>(1);
    public _userInfoData: IUserData;
    public isLogged: boolean = false;
    private _userRefCode: ReplaySubject<any> = new ReplaySubject<any>(1);

    constructor(
        private http: HttpClient
    ) { }
    initUserInfo(data: IUserData) {
        // let _data: IUserData;
        // _data = {
        //     playfabID: data.playfabId,
        //     loginEmail: data.email,
        //     recordedWallet: data.walletAddress
        // }
        //data.recordedWallet = "0x54AEA0dBB9419BA21e7E82b15019dD211f3da408";
        this._userInfoData = data;
        this._userInfo.next(data);
    }

    setUserLogged(value: boolean) {
        this.isLogged = value;
    }

    patchUserInfo(patch: Partial<IUserData>) {
        this._userInfo.next(
            {
                ...this._userInfoData,
                ...patch
            }
        )
    }

    get userInfo$(): Observable<IUserData> {
        return this._userInfo.asObservable();
    }

    getReferralCode(wallet: string): Observable<any> {
        return this.http.post(environment.apiBaseUrl + 'loyalty/getUserRefCode.php', { wallet: wallet }).pipe(
            tap(item => this._userRefCode.next(item))
        )
    }

    get userRefCode$(): Observable<any> {
        return this._userRefCode.asObservable();
    }
}
